







































































































































































































































































































































const namespace = 'admin';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { EventRegistration, EventTicket } from '../models/EventRegistration';
import GoogleLogIn from '../../../components/GoogleLogIn.vue';

import { countriesData } from '@/assets/data/ISO_3166-1_countries_pl';

@Component({
    name: 'Registrations',
    components: { GoogleLogIn },

    metaInfo() {
        return {
            title: 'Zouk Wroclove Admin',
        };
    },
})
export default class Registrations extends Vue {
    @Getter('loading', { namespace }) private loading!: number;
    @Getter('eventRegistrations', { namespace }) private eventRegistrations!: EventRegistration[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('fetchEventRegistrations', { namespace }) private fetchEventRegistrations: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('addEventRegistration', { namespace }) private addEventRegistration: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('patchEventRegistration', { namespace }) private patchEventRegistration: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('sendEventRegistrationConfirmation', { namespace }) private sendEventRegistrationConfirmation: any;

    @Getter('eventTickets', { namespace }) private eventTickets!: EventTicket[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('fetchEventTickets', { namespace }) private fetchEventTickets: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('addEventTicket', { namespace }) private addEventTicket: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('patchEventTicket', { namespace }) private patchEventTicket: any;

    private onExpand(event: any) {
        this.fetchEventTickets(event.item.id);
    }
    private search = '';
    private selected: EventRegistration | null = null;
    private expanded: EventRegistration[] = [];
    private headers = [
        {
            text: 'Event Registrations',
            align: 'start',
            sortable: true,
            value: 'id',
        },
        { text: 'Id', value: 'id' },
        { text: 'First name', value: 'firstName' },
        { text: 'Last Name', value: 'lastName' },
        { text: 'E-mail', value: 'email' },
        { text: 'Mobile number', value: 'mobileNumber' },
        { text: 'Sex type', value: 'sexTypeId' },
        { text: 'Event id', value: 'eventId' },
        { text: 'Guid', value: 'guid' },
        { text: 'Status', value: 'status' },
        { text: 'Comment', value: 'comment' },
        { text: 'Cancelled', value: 'cancelled' },
        { text: 'Created At', value: 'createdAt' },
        { text: 'Actions', value: 'actions', sortable: false },
    ];
    private ticketsHeaders = [
        {
            text: 'Event Tickets',
            align: 'start',
            sortable: true,
            value: 'id',
        },
        { text: 'Id', value: 'id' },
        { text: 'Name', value: 'name' },
        { text: 'Event id', value: 'eventId' },
        { text: 'Ticket type id', value: 'ticketTypeId' },
        { text: 'Guid', value: 'guid' },
        { text: 'Cancelled', value: 'cancelled' },
        { text: 'Price', value: 'price' },
        { text: 'Paid', value: 'paid' },
        { text: 'Comment', value: 'comment' },
        { text: 'Event participant id', value: 'eventParticipantId' },
        { text: 'Sex type', value: 'sexTypeId' },
        { text: 'Event registration id', value: 'eventRegistrationId' },
        { text: 'Actions', value: 'actions', sortable: false },
    ];
    private get countries() {
        const countries = countriesData
            .map((x: any) => ({ text: x.name_en, value: x.name_en }))
            .sort((x: any, y: any) => x.text.toLowerCase().localeCompare(y.value.toLowerCase()));
        // this.resources.unshift({ text: null, value: this.formField.Tooltip, Hidden: true });
        countries.unshift({ text: 'Polska', value: 'Poland' });
        return countries;
    }
    private sexItems = [
        { value: 1, text: 'Male / Mężczyzna' },
        { value: 2, text: 'Female / Kobieta' },
    ];
    private statuses = [
        { value: 'TicketChosen', text: 'TicketChosen' },
        { value: 'RegistrationPaid', text: 'RegistrationPaid' },
    ];
    private states = [
        { value: 3, text: 'TicketChosen' },
        { value: 4, text: 'RegistrationPaid' },
    ];
    private advanceLevelItems = [
        { value: 1, text: 'Beginner' },
        { value: 2, text: 'Intermediate' },
        { value: 3, text: 'Advanced' },
        { value: 4, text: 'Professional' },
    ];
    private dietTypeItems = [
        { value: 1, text: 'Mięsna' },
        { value: 2, text: 'Vegetarian' },
        { value: 3, text: 'Vegan' },
    ];
    private arrivalDateItems = [
        { value: 1, text: '2022-05-26 Thursday' },
        { value: 2, text: '2022-05-27 Friday' },
    ];
    private departureDateItems = [
        { value: 1, text: '2022-05-29 Sunday' },
        { value: 2, text: '2022-05-30 Monday' },
    ];
    private howLongDancingItems = [
        { value: 1, text: 'less then 1 year | mniej niż 1 rok' },
        { value: 2, text: 'less then 3 lata | mniej niż 3 lata' },
        { value: 3, text: 'less then 5 lata | mniej niż 5 lata' },
        { value: 4, text: 'more than 5 years | więcej niż 5 lata' },
    ];
    private howMuchDancingItems = [
        { value: 1, text: '1' },
        { value: 2, text: '2' },
        { value: 3, text: '3' },
        { value: 4, text: '4' },
        { value: 5, text: '5' },
        { value: 6, text: '6' },
        { value: 7, text: '7' },
        { value: 8, text: '8' },
        { value: 9, text: '9' },
        { value: 10, text: '10' },
    ];
    private tshirtSizeItems = [
        { value: 1, text: 'S' },
        { value: 2, text: 'M' },
        { value: 3, text: 'L' },
        { value: 4, text: 'XL' },
    ];
    private get formTitle() {
        return this.editedEventRegistrationIndex === -1 ? 'New Item' : 'Edit Item';
    }

    private getSexType(sexTypeId: number): string {
        return (this.sexItems.find(x => x.value == sexTypeId)?.text ?? '') as string;
    }

    private eventRegistrationDialog = false;
    private eventRegistrationDeleteDialog = false;
    private sendEventRegistrationConfirmationDialog = false;

    @Watch('eventRegistrationDialog', { immediate: true, deep: true })
    private dialogChanged(val: any) {
        val || this.closeEventRegistrationDialog();
    }

    @Watch('eventRegistrationDeleteDialog', { immediate: true, deep: true })
    private dialogDeleteChanged(val: any) {
        val || this.closeEventRegistrationDeleteDialog();
    }

    private editedEventRegistrationIndex = -1;
    private editedEventRegistration: EventRegistration = {
        id: 0,
        guid: '',
        firstName: '',
        lastName: '',
        eventId: 0,
        email: '',
        mobileNumber: '',
        status: '',
        stateId: 0,
        country: '',
        city: '',
        comment: '',
        cancelled: false,
        sexTypeId: 0,
        eventParticipantId: 0,
        selectedTickets: [],
    };
    private defaultEventRegistration: EventRegistration = {
        id: 0,
        guid: '',
        firstName: '',
        lastName: '',
        eventId: 0,
        email: '',
        mobileNumber: '',
        status: '',
        stateId: 0,
        country: '',
        city: '',
        comment: '',
        cancelled: false,
        sexTypeId: 0,
        eventParticipantId: 0,
        selectedTickets: [],
    };
    private editEventRegistration(item: EventRegistration) {
        this.editedEventRegistrationIndex = this.eventRegistrations.indexOf(item);
        this.editedEventRegistration = Object.assign({}, item);
        this.eventRegistrationDialog = true;
    }

    private deleteEventRegistration(item: EventRegistration) {
        this.editedEventRegistrationIndex = this.eventRegistrations.indexOf(item);
        this.editedEventRegistration = Object.assign({}, item);
        this.eventRegistrationDeleteDialog = true;
    }

    private async deleteEventRegistrationConfirm() {
        await this.patchEventRegistration({
            id: this.editedEventRegistration.id,
            cancelled: true,
            comment: 'Cancelled by Admin',
        });
        this.closeEventRegistrationDeleteDialog();
    }

    private showSendEventRegistrationConfirmationDialog(item: EventRegistration) {
        this.editedEventRegistrationIndex = this.eventRegistrations.indexOf(item);
        this.editedEventRegistration = Object.assign({}, item);
        this.sendEventRegistrationConfirmationDialog = true;
    }

    private async sendEventRegistrationConfirmationConfirm() {
        await this.sendEventRegistrationConfirmation(this.editedEventRegistration);
        this.closeEventRegistrationDeleteDialog();
    }

    private closeEventRegistrationDialog() {
        this.eventRegistrationDialog = false;
        this.$nextTick(() => {
            this.editedEventRegistration = Object.assign({}, this.defaultEventRegistration);
            this.editedEventRegistrationIndex = -1;
        });
    }

    private closeEventRegistrationDeleteDialog() {
        this.eventRegistrationDeleteDialog = false;
        this.sendEventRegistrationConfirmationDialog = false;
        this.$nextTick(() => {
            this.editedEventRegistration = Object.assign({}, this.defaultEventRegistration);
            this.editedEventRegistrationIndex = -1;
        });
    }

    private async saveEventRegistration() {
        if (this.editedEventRegistrationIndex > -1) {
            await this.patchEventRegistration(this.editedEventRegistration);
            await this.fetchEventRegistrations();
        } else {
            await this.addEventRegistration(this.editedEventRegistration);
            await this.fetchEventRegistrations();
        }
        this.closeEventRegistrationDialog();
    }

    private eventTicketDialog = false;
    private eventTicketDeleteDialog = false;

    @Watch('eventTicketDialog', { immediate: true, deep: true })
    private eventTicketDialogChanged(val: any) {
        val || this.closeEventTicketDialog();
    }

    @Watch('eventTicketDeleteDialog', { immediate: true, deep: true })
    private eventTicketDeleteDialogChanged(val: any) {
        val || this.closeEventTicketDeleteDialog();
    }

    private editedEventTicketIndex = -1;
    private editedEventTicket: EventTicket = {
        id: 0,
        name: '',
        eventId: 0,
        ticketTypeId: 0,
        guid: '',
        cancelled: false,
        price: 0,
        paid: null,
        eventParticipantId: 0,
        sexTypeId: 0,
        eventRegistrationId: 0,
        comment: '',
    };
    private defaultEventTicket: EventTicket = {
        id: 0,
        name: null,
        eventId: 0,
        ticketTypeId: 0,
        guid: '',
        comment: '',
        cancelled: false,
        price: null,
        paid: null,
        eventParticipantId: 0,
        sexTypeId: this.expanded[0]?.sexTypeId ?? 0,
        eventRegistrationId: this.expanded[0]?.id ?? 0,
    };
    private editEventTicket(item: EventTicket) {
        this.editedEventTicketIndex = this.eventTickets.indexOf(item);
        this.editedEventTicket = Object.assign({}, item);
        this.eventTicketDialog = true;
    }

    private deleteEventTicket(item: EventTicket) {
        this.editedEventTicketIndex = this.eventTickets.indexOf(item);
        this.editedEventTicket = Object.assign({}, item);
        this.eventTicketDeleteDialog = true;
    }

    private async deleteEventTicketConfirm() {
        const eventRegistrationId = this.expanded[0]?.id ?? 0;
        await this.patchEventTicket({
            id: this.editedEventTicket.id,
            cancelled: true,
            comment: 'Cancelled by Admin',
        });
        await this.fetchEventTickets(eventRegistrationId);
        this.closeEventTicketDeleteDialog();
    }

    private closeEventTicketDialog() {
        this.eventTicketDialog = false;
        this.$nextTick(() => {
            this.editedEventTicket = Object.assign({}, this.defaultEventTicket);
            this.editedEventTicketIndex = -1;
        });
    }

    private closeEventTicketDeleteDialog() {
        this.eventTicketDeleteDialog = false;
        this.$nextTick(() => {
            this.editedEventTicket = Object.assign({}, this.defaultEventTicket);
            this.editedEventTicketIndex = -1;
        });
    }

    private async saveEventTicket() {
        const eventRegistrationId = this.expanded[0]?.id ?? 0;
        if (this.editedEventTicketIndex > -1) {
            await this.patchEventTicket(this.editedEventTicket);
            await this.fetchEventTickets(eventRegistrationId);
        } else {
            this.editedEventTicket.eventRegistrationId = eventRegistrationId;
            await this.addEventTicket(this.editedEventTicket);
            await this.fetchEventTickets(eventRegistrationId);
        }
        this.closeEventTicketDialog();
    }
}
